(() => {
  "use strict";
  const config = {
    parents: [
      "16387524034947",
      "16386706669955",
      "15327984746883",
      "15327984550275",
      "15327984910723",
      "15327985795459",
      "15395457008003",
      "15381406351747",
      "15327980126595",
      "15327981502851",
      "15327985729923",
      "15327985566083",
      "15327984386435",
      "15327984189827",
      "15327980290435",
    ],
    prints: {
      large_back: 62832539206019,
      small_front: 62830485307779,
      large_front: 62830489076099,
      small_front_back: 62830489108867,
      large_front_back: 62830489141635,
    },
    size: { 450: 62837064532355, 100: 62830489174403, 150: 62830489207171, 200: 62830489239939 },
    large: [
      "62830488420739",
      "62830488453507",
      "56182515171715",
      "62823927808387",
      "62823927841155",
      "62823927873923",
      "56182515204483",
      "62823927906691",
      "62823927939459",
      "62823927972227",
      "56182515237251",
      "62823928004995",
      "62823928037763",
      "62823928070531",
      "56182515270019",
      "62823928103299",
      "62823928136067",
      "62823928168835",
      "56182515302787",
      "62823928201603",
      "62823928234371",
      "62823928267139",
      "56182515335555",
      "62823928299907",
      "62823928332675",
      "62823928365443",
      "56182516351363",
      "62823931347331",
      "62823931380099",
      "62823931412867",
      "56182516384131",
      "62823931445635",
      "62823931478403",
      "62823931511171",
      "56182516416899",
      "62823931543939",
      "62823931576707",
      "62823931609475",
      "56182516449667",
      "62823931642243",
      "62823931675011",
      "62823931707779",
      "56182516482435",
      "62823931740547",
      "62823931773315",
      "62823931806083",
      "56182516515203",
      "62823931838851",
      "62823931871619",
      "62823931904387",
      "56182516547971",
      "62823931937155",
      "62823931969923",
      "62823932002691",
      "56182516580739",
      "62823932035459",
      "62823932068227",
      "62823932100995",
      "56182516613507",
      "62823932133763",
      "62823932166531",
      "62823932199299",
      "56182516646275",
      "62823932232067",
      "62823932264835",
      "62823932297603",
      "56182516679043",
      "62823932330371",
      "62823932363139",
      "62823932395907",
      "56182516711811",
      "62823932428675",
      "62823932461443",
      "62823932494211",
      "56182516744579",
      "62823932526979",
      "62823932559747",
      "62823932592515",
      "56182516777347",
      "62823932625283",
      "62823932658051",
      "62823932690819",
      "56182516810115",
      "62823932723587",
      "62823932756355",
      "62823932789123",
    ],
    sizeAmounts: {
      62830488420739: 100,
      62830488453507: 100,
      56182515171715: 100,
      62823927808387: 100,
      62823927841155: 100,
      62823927873923: 100,
      56182515204483: 100,
      62823927906691: 100,
      62823927939459: 100,
      62823927972227: 100,
      56182515237251: 100,
      62823928004995: 100,
      62823928037763: 100,
      62823928070531: 100,
      56182515270019: 100,
      62823928103299: 100,
      62823928136067: 100,
      62823928168835: 100,
      56182515302787: 100,
      62823928201603: 100,
      62823928234371: 100,
      62823928267139: 100,
      56182515335555: 100,
      62823928299907: 100,
      62823928332675: 100,
      62823928365443: 100,
      56182516351363: 100,
      62823931347331: 100,
      62823931380099: 100,
      62823931412867: 100,
      56182516384131: 100,
      62823931445635: 100,
      62823931478403: 100,
      62823931511171: 100,
      56182516416899: 100,
      62823931543939: 100,
      62823931576707: 100,
      62823931609475: 100,
      56182516449667: 100,
      62823931642243: 100,
      62823931675011: 100,
      62823931707779: 100,
      56182516482435: 100,
      62823931740547: 100,
      62823931773315: 100,
      62823931806083: 100,
      56182516515203: 100,
      62823931838851: 100,
      62823931871619: 100,
      62823931904387: 100,
      56182516547971: 100,
      62823931937155: 100,
      62823931969923: 100,
      62823932002691: 100,
      56182516580739: 100,
      62823932035459: 100,
      62823932068227: 100,
      62823932100995: 100,
      56182516613507: 100,
      62823932133763: 100,
      62823932166531: 100,
      62823932199299: 100,
      56182516646275: 100,
      62823932232067: 100,
      62823932264835: 100,
      62823932297603: 100,
      56182516679043: 100,
      62823932330371: 100,
      62823932363139: 100,
      62823932395907: 100,
      56182516711811: 100,
      62823932428675: 100,
      62823932461443: 100,
      62823932494211: 100,
      56182516744579: 100,
      62823932526979: 100,
      62823932559747: 100,
      62823932592515: 100,
      56182516777347: 100,
      62823932625283: 100,
      62823932658051: 100,
      62823932690819: 100,
      56182516810115: 100,
      62823932723587: 100,
      62823932756355: 100,
      62823932789123: 100,
      56182512976259: 100,
      56182513009027: 100,
      56182513041795: 100,
      56182513074563: 100,
      56182513107331: 100,
      56182513140099: 100,
      56182513500547: 100,
      56182513533315: 100,
      56182517465475: 200,
      56182518317443: 200,
      56182518350211: 200,
      56182518382979: 200,
      56182518415747: 200,
      56182518448515: 200,
      56518179291523: 100,
      56518179324291: 100,
      56452288283011: 200,
      56452288446851: 200,
      56452288610691: 200,
      56452288774531: 200,
      56452288938371: 200,
      56452289102211: 200,
      56452289266051: 200,
      56182454649219: 100,
      56182454681987: 100,
      56182454878595: 100,
      56182479323523: 150,
      56182479356291: 150,
      56182479389059: 150,
      56182479421827: 150,
      56182523462019: 150,
      56182523003267: 100,
      56182523036035: 100,
      56182523068803: 100,
      62826942726531: 100,
      62826942759299: 100,
      62826942792067: 100,
      62826942988675: 100,
      62826943185283: 100,
      62826943381891: 100,
      62826943414659: 100,
      62826943447427: 100,
      62826943644035: 100,
      62826943840643: 100,
      62826944037251: 100,
      62826944233859: 100,
      62826944430467: 100,
      62826944627075: 100,
      62826944823683: 100,
      62826945020291: 100,
      62826945216899: 100,
      62826945249667: 100,
      62826945282435: 100,
      62826945479043: 100,
      62826945675651: 100,
      62826945872259: 100,
      62826946068867: 100,
      62826946265475: 100,
      62826946462083: 100,
      62826946658691: 100,
      56182511141251: 150,
      56182511174019: 150,
      56182511206787: 150,
      56182511239555: 150,
      56182509732227: 100,
      56182509764995: 100,
      56182509961603: 100,
      56182460449155: 150,
      56182460481923: 150,
    },
    version: "collection-2026-10-15",
  };
  let registry = null,
    registryPromise = null;
  function applyRegistry(value) {
    if (value?.version !== 1 || !value.products || typeof value.products != "object")
      throw new Error(
        "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u0442\u0435 \u0437\u0430 \u0440\u0430\u0431\u043E\u0442\u043D\u043E \u043E\u0431\u043B\u0435\u043A\u043B\u043E \u043D\u0435 \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0431\u044A\u0434\u0430\u0442 \u0437\u0430\u0440\u0435\u0434\u0435\u043D\u0438.",
      );
    ((registry = value.products),
      (config.parents = Object.keys(registry).filter((id) => registry[id].enabled === !0)));
  }
  async function loadRegistry() {
    if (!registry)
      return (
        registryPromise ||
        ((registryPromise = (async () => {
          const embedded = document.querySelector("[data-fd-workwear-registry]");
          if (embedded) {
            applyRegistry(JSON.parse(embedded.textContent));
            return;
          }
          const root2 = window.Shopify?.routes?.root || "/",
            response = await fetch(root2 + "?section_id=fd-linked-atomic", { cache: "no-store" });
          if (!response.ok)
            throw new Error(
              "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438\u0442\u0435 \u0437\u0430 \u0440\u0430\u0431\u043E\u0442\u043D\u043E \u043E\u0431\u043B\u0435\u043A\u043B\u043E \u043D\u0435 \u043C\u043E\u0433\u0430\u0442 \u0434\u0430 \u0431\u044A\u0434\u0430\u0442 \u0437\u0430\u0440\u0435\u0434\u0435\u043D\u0438.",
            );
          const node = new DOMParser()
            .parseFromString(await response.text(), "text/html")
            .querySelector("[data-fd-workwear-registry]");
          if (!node)
            throw new Error(
              "\u041B\u0438\u043F\u0441\u0432\u0430\u0442 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0437\u0430 \u0440\u0430\u0431\u043E\u0442\u043D\u043E \u043E\u0431\u043B\u0435\u043A\u043B\u043E.",
            );
          applyRegistry(JSON.parse(node.textContent));
        })().catch((error) => {
          throw ((registryPromise = null), error);
        })),
        registryPromise)
      );
  }
  const isParent = (item) =>
      config.parents.includes(String(item.product_id)) && item.properties?._fd_link_version === "1",
    isChild = (item) => item.properties?._fd_link_role === "fee";
  function expected(parent) {
    const model = registry?.[String(parent.product_id)],
      choice = parent.properties._fd_print,
      permitted =
        model?.print_mode === "front"
          ? ["small_front"]
          : model?.print_mode === "zip"
            ? ["small_front", "large_back", "small_front_back"]
            : ["small_front", "large_front", "small_front_back", "large_front_back"];
    if (model && !permitted.includes(choice))
      throw new Error(
        "\u0418\u0437\u0431\u0440\u0430\u043D\u0438\u044F\u0442 \u043F\u0435\u0447\u0430\u0442 \u043D\u0435 \u0435 \u043D\u0430\u043B\u0438\u0447\u0435\u043D \u0437\u0430 \u0442\u043E\u0437\u0438 \u043C\u043E\u0434\u0435\u043B.",
      );
    const print = config.prints[choice];
    if (!print)
      throw new Error(
        "\u041B\u0438\u043F\u0441\u0432\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u043D \u0438\u0437\u0431\u043E\u0440 \u043D\u0430 \u043F\u0435\u0447\u0430\u0442.",
      );
    const fees = [print],
      sizeAmount = model
        ? model.extra_sizes.includes(parent.variant_options?.[model.size_index])
          ? model.extra_amount
          : 0
        : config.sizeAmounts[String(parent.variant_id)];
    if (sizeAmount && !config.size[String(sizeAmount)])
      throw new Error(
        "\u041D\u0430\u0434\u0431\u0430\u0432\u043A\u0430\u0442\u0430 \u0437\u0430 \u0440\u0430\u0437\u043C\u0435\u0440 \u043D\u0435 \u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0435\u043D\u0430.",
      );
    return (sizeAmount && fees.push(config.size[String(sizeAmount)]), fees);
  }
  function plan(cart) {
    const updates = {},
      add = [],
      parents = cart.items.filter(isParent),
      tokens = new Set();
    for (const parent of parents) {
      const token = parent.properties._fd_link;
      if (!token || tokens.has(token))
        throw new Error(
          "\u041D\u0435\u0435\u0434\u043D\u043E\u0437\u043D\u0430\u0447\u043D\u0430 \u0432\u0440\u044A\u0437\u043A\u0430 \u043C\u0435\u0436\u0434\u0443 \u0434\u0440\u0435\u0445\u0430 \u0438 \u043F\u0435\u0447\u0430\u0442.",
        );
      tokens.add(token);
      const expectedIds = expected(parent),
        children = cart.items.filter((item) => isChild(item) && item.properties._fd_link === token);
      for (const variantId of expectedIds) {
        const matching = children.filter(
          (item) =>
            String(item.variant_id) === String(variantId) &&
            item.parent_relationship?.parent_key === parent.key,
        );
        (matching.length ||
          add.push({
            id: variantId,
            quantity: parent.quantity,
            parent_line_key: parent.key,
            properties: {
              _fd_link_role: "fee",
              _fd_link: token,
              "\u041A\u044A\u043C \u043F\u0440\u043E\u0434\u0443\u043A\u0442": parent.product_title,
              Вариант: parent.variant_title || parent.title,
            },
          }),
          matching.forEach((child, index) => {
            const target = index ? 0 : parent.quantity;
            child.quantity !== target && (updates[child.key] = target);
          }));
      }
      for (const child of children)
        (!expectedIds.some((id) => String(id) === String(child.variant_id)) ||
          child.parent_relationship?.parent_key !== parent.key) &&
          (updates[child.key] = 0);
    }
    for (const child of cart.items.filter(isChild))
      tokens.has(child.properties._fd_link) || (updates[child.key] = 0);
    return { updates, add };
  }
  function minimumViolation(cart) {
    const totals = new Map();
    for (const item of cart.items) {
      const id = String(item.product_id),
        model = registry?.[id],
        minimum = Math.max(1, Number(model?.min_quantity) || 1);
      if (!model?.enabled || minimum <= 1) continue;
      const entry = totals.get(id) || {
        quantity: 0,
        minimum,
        title: item.product_title || item.title || "Този модел",
      };
      entry.quantity += Number(item.quantity) || 0;
      totals.set(id, entry);
    }
    for (const entry of totals.values())
      if (entry.quantity > 0 && entry.quantity < entry.minimum)
        return (
          "Минималната поръчка за „" +
          entry.title +
          "“ е " +
          entry.minimum +
          " броя общо. В количката има " +
          entry.quantity +
          ". Добави още " +
          (entry.minimum - entry.quantity) +
          " броя или премахни модела изцяло."
        );
    return "";
  }
  const api = { config, plan, isParent, isChild, applyRegistry, loadRegistry, minimumViolation };
  if (typeof module < "u" && module.exports) {
    module.exports = api;
    return;
  }
  if (window.FDLinkedCart) return;
  const root = window.Shopify?.routes?.root || "/";
  let queue = Promise.resolve(),
    busy = !1,
    passingCheckout = !1;
  async function request(path, body) {
    const response = await fetch(root + "cart" + path + ".js", {
        method: body ? "POST" : "GET",
        headers: {
          Accept: "application/json",
          ...(body ? { "Content-Type": "application/json" } : {}),
        },
        ...(body ? { body: JSON.stringify(body) } : {}),
        cache: "no-store",
      }),
      data = await response.json();
    if (!response.ok)
      throw new Error(
        typeof data.description == "string"
          ? data.description
          : "\u041A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430 \u043D\u0435 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0441\u0435 \u043E\u0431\u043D\u043E\u0432\u0438.",
      );
    return data;
  }
  const read = () => request("");
  async function reconcile() {
    for (let attempt = 0; attempt < 4; attempt++) {
      const cart = await read();
      cart.items.some(
        (item) =>
          item.properties?._fd_link_version === "1" ||
          isChild(item) ||
          String(item.product_id) === "16391755366787",
      ) && (await loadRegistry());
      const changes = plan(cart);
      if (Object.keys(changes.updates).length) {
        await request("/update", { updates: changes.updates });
        continue;
      }
      if (changes.add.length) {
        await request("/add", { items: changes.add });
        continue;
      }
      return cart;
    }
    throw new Error(
      "\u041F\u0435\u0447\u0430\u0442\u044A\u0442 \u0438 \u0440\u0430\u0437\u043C\u0435\u0440\u0438\u0442\u0435 \u043D\u0435 \u0441\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0434\u0435\u043D\u0438. \u041E\u043F\u0438\u0442\u0430\u0439 \u043E\u0442\u043D\u043E\u0432\u043E \u043F\u0440\u0435\u0434\u0438 \u043F\u043B\u0430\u0449\u0430\u043D\u0435.",
    );
  }
  function announce(message) {
    let box = document.getElementById("fd-linked-cart-status");
    (box ||
      ((box = document.createElement("div")),
      (box.id = "fd-linked-cart-status"),
      box.setAttribute("role", "status"),
      (box.style.cssText =
        "position:fixed;bottom:16px;left:16px;right:16px;z-index:10000;padding:14px;background:#fff;border:1px solid #ccc;border-radius:10px;color:#222;box-shadow:0 2px 12px #0002"),
      document.body.append(box)),
      (box.textContent = message),
      (box.hidden = !message));
  }
  function exclusive(task) {
    const next = queue
      .catch(() => {})
      .then(async () => {
        ((busy = !0), document.documentElement.setAttribute("data-fd-cart-busy", "true"));
        try {
          return await task();
        } finally {
          ((busy = !1), document.documentElement.removeAttribute("data-fd-cart-busy"));
        }
      });
    return ((queue = next), next);
  }
  async function refresh(cart) {
    const drawer =
        document.querySelector("cart-drawer") || document.querySelector("cart-notification"),
      targets = ["main-cart-items", "main-cart-footer"]
        .map((id) => document.getElementById(id))
        .filter(Boolean),
      sectionIds = targets
        .map(
          (element) =>
            element.dataset.id ||
            element.closest('[id^="shopify-section-"]')?.id.replace("shopify-section-", ""),
        )
        .filter(Boolean),
      sections = [...new Set(["cart-drawer", "cart-icon-bubble", ...sectionIds])].slice(0, 5),
      url = new URL(location.href);
    url.searchParams.set("sections", sections.join(","));
    const response = await fetch(url, { cache: "no-store" });
    if (!response.ok)
      throw new Error(
        "\u041A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430 \u0435 \u043E\u0431\u043D\u043E\u0432\u0435\u043D\u0430. \u041F\u0440\u0435\u0437\u0430\u0440\u0435\u0434\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0442\u0430, \u0437\u0430 \u0434\u0430 \u0432\u0438\u0434\u0438\u0448 \u0441\u0443\u043C\u0430\u0442\u0430.",
      );
    const html = await response.json();
    for (const target of targets) {
      const id =
        target.dataset.id ||
        target.closest('[id^="shopify-section-"]')?.id.replace("shopify-section-", "");
      if (html[id]) {
        const doc = new DOMParser().parseFromString(html[id], "text/html"),
          wrapper = target.closest('[id^="shopify-section-"]'),
          next = wrapper ? doc.getElementById(wrapper.id) : null;
        if (wrapper && next) wrapper.innerHTML = next.innerHTML;
        else {
          const node = doc.getElementById(target.id);
          node && (target.innerHTML = node.innerHTML);
        }
      }
    }
    if (drawer && html["cart-drawer"]) {
      const fresh = new DOMParser()
        .parseFromString(html["cart-drawer"], "text/html")
        .querySelector("cart-drawer");
      fresh &&
        ((drawer.innerHTML = fresh.innerHTML),
        drawer.classList.toggle("is-empty", !cart.item_count),
        /\/cart\/?$/.test(location.pathname) ||
          (typeof drawer.open == "function"
            ? drawer.open()
            : (drawer.classList.add("active"), document.body.classList.add("overflow-hidden"))));
    }
    if (html["cart-icon-bubble"]) {
      const icon = document.getElementById("cart-icon-bubble"),
        doc = new DOMParser().parseFromString(html["cart-icon-bubble"], "text/html");
      icon &&
        (icon.innerHTML = (
          doc.getElementById("shopify-section-cart-icon-bubble") || doc.body
        ).innerHTML);
    }
    (document.querySelectorAll("fd-linked-test, fd-linked-atomic").forEach((element) => {
      ((element.cartQuantity = cart.items
        .filter(isParent)
        .reduce((sum, item) => sum + item.quantity, 0)),
        !element.locked && typeof element.update == "function" && element.update());
    }),
      document.dispatchEvent(new CustomEvent("fd:cart-synced", { detail: cart })));
  }
  function sync({ render = !1, checkMinimum = !1 } = {}) {
    return exclusive(async () => {
      const cart = await reconcile();
      const minimumMessage = minimumViolation(cart);
      if (checkMinimum && minimumMessage) throw new Error(minimumMessage);
      return (render && (await refresh(cart)), announce(minimumMessage), cart);
    });
  }
  function change(key, quantity) {
    return (
      announce(
        "\u041E\u0431\u043D\u043E\u0432\u044F\u0432\u0430\u043C\u0435 \u0434\u0440\u0435\u0445\u0438\u0442\u0435 \u0438 \u0441\u0432\u044A\u0440\u0437\u0430\u043D\u0438\u0442\u0435 \u0442\u0430\u043A\u0441\u0438\u2026",
      ),
      exclusive(async () => {
        if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > 1e4)
          throw new Error(
            "\u0412\u044A\u0432\u0435\u0434\u0438 \u0446\u044F\u043B\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043C\u0435\u0436\u0434\u0443 0 \u0438 10000.",
          );
        const cart = await read(),
          parent = cart.items.find((item) => item.key === key);
        if (!parent || !isParent(parent))
          throw new Error(
            "\u0410\u0440\u0442\u0438\u043A\u0443\u043B\u044A\u0442 \u0435 \u043F\u0440\u043E\u043C\u0435\u043D\u0435\u043D. \u041F\u0440\u0435\u0437\u0430\u0440\u0435\u0434\u0438 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430.",
          );
        const updates = { [parent.key]: quantity };
        for (const child of cart.items.filter(
          (item) => isChild(item) && item.properties._fd_link === parent.properties._fd_link,
        ))
          updates[child.key] = quantity;
        await request("/update", { updates });
        const result = await reconcile();
        return (await refresh(result), announce(minimumViolation(result)), result);
      })
    );
  }
  const fail = (error) =>
    announce(
      error.message ||
        "\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u043D\u0430 \u043A\u043E\u043B\u0438\u0447\u043A\u0430\u0442\u0430.",
    );
  (document.addEventListener(
    "change",
    (event) => {
      const input = event.target.closest('input[name="updates[]"]'),
        row = input?.closest("[data-fd-linked-key]");
      row &&
        (event.preventDefault(),
        event.stopImmediatePropagation(),
        row.dataset.fdLinkedRole === "parent" &&
          change(row.dataset.fdLinkedKey, Number(input.value)).catch(fail));
    },
    !0,
  ),
    document.addEventListener(
      "click",
      (event) => {
        const row = event.target
          .closest('cart-remove-button, a[href*="/cart/change"]')
          ?.closest("[data-fd-linked-key]");
        if (row) {
          (event.preventDefault(),
            event.stopImmediatePropagation(),
            row.dataset.fdLinkedRole === "parent" &&
              change(row.dataset.fdLinkedKey, 0).catch(fail));
          return;
        }
        busy &&
          event.target.closest('[name="checkout"],a[href*="/checkout"]') &&
          (event.preventDefault(), event.stopImmediatePropagation());
        const checkout = event.target.closest('a[href*="/checkout"]');
        checkout &&
          !passingCheckout &&
          (event.preventDefault(),
          event.stopImmediatePropagation(),
          sync({ checkMinimum: !0 })
            .then(() => {
              location.assign(checkout.href);
            })
            .catch(fail));
      },
      !0,
    ),
    document.addEventListener(
      "submit",
      (event) => {
        if (
          passingCheckout ||
          !(event.submitter?.name === "checkout" || /\/checkout/.test(event.target.action))
        )
          return;
        (event.preventDefault(), event.stopImmediatePropagation());
        const form = event.target,
          button = event.submitter;
        sync({ checkMinimum: !0 })
          .then(() => {
            passingCheckout = !0;
            try {
              form.requestSubmit(button || void 0);
            } finally {
              passingCheckout = !1;
            }
          })
          .catch(fail);
      },
      !0,
    ),
    (window.FDLinkedCart = { ...api, read, sync, change, refresh, fail }),
    (document.documentElement.dataset.fdLinkedLoaded = "1"),
    /\/cart\/?$/.test(location.pathname) && sync({ render: !1 }).catch(fail));
})();
